/**
 * SortIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const SortIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      d="M11.727 8.297 6.721 3.3a1.003 1.003 0 0 0-1.422 0L.293 8.297a.998.998 0 0 0 1.412 1.41l3.294-3.289v13.583c0 .55.45.999 1.001.999s1.001-.45 1.001-1V6.418l3.294 3.288a.998.998 0 0 0 1.412-1.409zm.546 7.406 5.006 4.997a1.003 1.003 0 0 0 1.422 0l5.006-4.997a.998.998 0 0 0-1.412-1.41l-3.294 3.289V3.999c0-.55-.45-.999-1.001-.999s-1.001.45-1.001 1v13.582l-3.294-3.289a.998.998 0 0 0-1.412 1.41z"
      clipRule="evenodd"
    />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const SortIcon = makeIcon('SortIcon', SortIconSvg)
